import { render, staticRenderFns } from "./coinTable.vue?vue&type=template&id=1f9e4da0&scoped=true&"
import script from "./coinTable.vue?vue&type=script&lang=js&"
export * from "./coinTable.vue?vue&type=script&lang=js&"
import style0 from "./coinTable.vue?vue&type=style&index=0&id=1f9e4da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e4da0",
  null
  
)

export default component.exports